import { makeRequestAction } from './index';

export const fetchLenderAnalytics = makeRequestAction('LENDER_ANALYTICS', {
  onSuccess(params, response) {
    return {
      response: {
        ...response,
      },
    };
  },
});
